import { render, staticRenderFns } from "./InputFormatNumber.vue?vue&type=template&id=35fcb494&"
import script from "./InputFormatNumber.vue?vue&type=script&lang=js&"
export * from "./InputFormatNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports